import script from "./mediaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./mediaModal.vue?vue&type=script&setup=true&lang=js"

import "./mediaModal.vue?vue&type=style&index=0&id=52bb4e90&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52bb4e90"]])

export default __exports__